// Functionality is also located in js/foot/shared/tab-containers.js

